<template>
	<div
		v-if="loading"
		class="d-flex justify-content-center align-items-center"
		style="height: calc(100vh - 80px); flex-direction: column"
	>
		<b-spinner :label="$t('loadingPage')" />
	</div>
	<!-- eslint-disable-next-line vue/no-v-html -->
	<div v-else-if="page && page.id" class="px-3" v-html="page.body" />
</template>

<script>
	export default {
		props: {
			slug: {
				type: String,
				default: null
			}
		},
		data () {
			return {
				loading: true,
				page: null
			}
		},
		beforeMount () {
			this.getPage()
		},
		methods: {
			getPage () {
				this.$store.dispatch('getPages', {
					slug: this.slug || this.$route.params.slug.replace(/-/g, '_')
				}).then((response) => {
					this.page = response.data.pages
				}).catch((err) => {
					this.showErrors(err)
				}).finally(() => {
					this.loading = false
				})
			}
		}
	}
</script>
